/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1StatsByDriversOverviewResponse } from '../../entities/v1/StatsByDriversOverviewResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1OverviewByDriversModelSchema } from './overviewByDriversModelSchema'
import { z } from 'zod'

export const v1StatsByDriversOverviewResponseSchema = z.object({
  overview: z.lazy(() => v1OverviewByDriversModelSchema),
}) as unknown as ToZod<V1StatsByDriversOverviewResponse>